import * as types from '../actions/external-integration-actions-types';


const SET_EXTERNAL_INTEGRATIONS_CONFIG_INITIAL_STATE = {
	isLoading: false,
	results: {},
	error: '',
};

export function setExternalIntegrationsConfigReducer(state = SET_EXTERNAL_INTEGRATIONS_CONFIG_INITIAL_STATE, action) {
	switch (action.type) {
		case types.SET_EXTERNAL_INTEGRATIONS_CONFIG:
			return { ...state, isLoading: false, results: action.payload };
		default:
			return state;
	}
}